import React, { useEffect, useRef, useState } from 'react';
import { aboutData } from '../data/mock';

const About = () => {
  const introRef = useRef(null);
  const imageRef = useRef(null);
  const [imageVisible, setImageVisible] = useState(false);

  useEffect(() => {
    const textObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const chars = entry.target.querySelectorAll('.char-reveal');
            chars.forEach((char, index) => {
              setTimeout(() => {
                char.classList.add('visible');
              }, index * 20);
            });
            textObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    const imageObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setImageVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (introRef.current) {
      textObserver.observe(introRef.current);
    }

    if (imageRef.current) {
      imageObserver.observe(imageRef.current);
    }

    return () => {
      textObserver.disconnect();
      imageObserver.disconnect();
    };
  }, []);

  return (
    <section id="about" className="editorial-about-section">
      <div className="container">
        <div className="about-label-wrapper">
          <h2 className="section-label">(About.)</h2>
        </div>

        <div className="about-grid">
          <div className="about-image-column" ref={imageRef}>
            <img 
              src={aboutData.image} 
              alt="Sakshi Jain"
              className={`about-portrait ${imageVisible ? 'mobile-visible' : ''}`}
            />
          </div>

          <div className="about-text-column">
            <div className="about-intro-text" ref={introRef}>
              {(() => {
                const words = aboutData.intro.split(' ');
                let charCount = 0;
                return words.map((word, wordIndex) => (
                  <React.Fragment key={wordIndex}>
                    <span style={{ whiteSpace: 'nowrap', display: 'inline' }}>
                      {word.split('').map((char, charIndex) => {
                        const idx = charCount++;
                        return (
                          <span key={idx} className="char-reveal" style={{ display: 'inline-block' }}>
                            {char}
                          </span>
                        );
                      })}
                    </span>
                    {wordIndex < words.length - 1 && (() => {
                      charCount++;
                      return <span className="char-reveal" style={{ display: 'inline' }}>{' '}</span>;
                    })()}
                  </React.Fragment>
                ));
              })()}
            </div>
            <p className="about-body-text">{aboutData.body}</p>

            <div className="about-stats-inline">
              <div className="stat-inline">
                <span className="stat-number-inline">{aboutData.stats.growth}</span>
                <span className="stat-label-inline">Average Growth</span>
              </div>
              <div className="stat-inline">
                <span className="stat-number-inline">{aboutData.stats.experience}</span>
                <span className="stat-label-inline">Industry Experience</span>
              </div>
              <div className="stat-inline">
                <span className="stat-number-inline">{aboutData.stats.brands}</span>
                <span className="stat-label-inline">Brands Consulted</span>
              </div>
              <div className="stat-inline">
                <span className="stat-number-inline">{aboutData.stats.revenue}</span>
                <span className="stat-label-inline">Revenue Managed</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
